import type { ConnectOptions } from '../connect'
/** One server target. Minecraft identity is always provided by Microsoft authentication. */
export function privateConnection(protocol: string, host: string): ConnectOptions {
  return { server: `${protocol === 'https:' ? 'wss' : 'ws'}://${host}/play`, username: 'Microsoft account', botVersion: '1.20.4', proxy: `${protocol}//${host}`, authenticatedAccount: true, ignoreQs: true, saveServerToHistory: false }
}
